<template>
  <div class="heade">
    <!-- 左侧 Logo & 系统标题 -->
    <div class="header_l">
      <div class="logo">
        <img class="logo_img" src="@/assets/logo1.png" alt="logo" />
        <span class="logo_text">金航科技</span>
      </div>
      <span class="split_line">|</span>
      <span class="title">江苏金航智能科技设备管理系统</span>
    </div>

    <!-- 中间：实时时钟 -->
    <div class="header_c">
      <div class="clock_time">{{ timeStr }}</div>
      <div class="clock_date">{{ dateStr }}</div>
    </div>

    <!-- 右侧：用户信息 & 功能 -->
    <div class="flex a-l-c user_r">
      <span class="text_dow" @click="kehudialogVisible = true">
        <el-icon color="#00ff88">
          <UserFilled />
        </el-icon>联系我们
      </span>
      <span class="user_name">{{ users.name }}</span>
      <el-avatar class="user" :src="users.avatarUrl" />
      <span class="conle">|</span>
      <span class="text_dow text_logout" @click="loginOutFunc">
        <el-icon color="#ef4444">
          <SwitchButton />
        </el-icon>退出登录
      </span>
    </div>

    <!-- 联系我们弹窗 -->
    <el-dialog v-model="kehudialogVisible" title="有问题随时联系我们" width="340" :before-close="handleClose">
      <div class="dialog-content text-center py-4">
         <p class="text-sm text-gray-500 mb-2">服务专线: 0512-XXXXXXXX</p>
         <p class="text-xs text-gray-400">我们将为您提供全天候的技术支持与保障。</p>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { User, Lock, Warning, UserFilled, SwitchButton } from "@element-plus/icons-vue";
import { onMounted, ref, onBeforeUnmount } from "vue";
import { ElMessageBox } from 'element-plus';
import { useRouter } from "vue-router";

const kehudialogVisible = ref(false);
const router = useRouter();
const users = ref({});
const timeStr = ref("");
const dateStr = ref("");
let clockTimer = null;

const updateClock = () => {
  const now = new Date();
  timeStr.value = now.toTimeString().slice(0, 8);
  dateStr.value = now.getFullYear() + '-' + 
                  String(now.getMonth() + 1).padStart(2, '0') + '-' + 
                  String(now.getDate()).padStart(2, '0');
};

onMounted(() => {
  let userInfo = localStorage.getItem("user");
  if (userInfo) {
    const user = JSON.parse(userInfo).user.users;
    users.value = user;
  }
  updateClock();
  clockTimer = setInterval(updateClock, 1000);
});

onBeforeUnmount(() => {
  if (clockTimer) clearInterval(clockTimer);
});

const loginOutFunc = () => {
  ElMessageBox.confirm(
    '确认退出登录吗?',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
  .then(() => {
    localStorage.removeItem('store');
    localStorage.removeItem('user');
    router.push("/login");
  })
  .catch(() => {});
};
</script>

<style lang="less" scoped>
.heade {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #0b0f16;
  height: 100%;
  padding: 0 24px;
  font-size: 14px;
  color: #fff;
  border-bottom: 1px solid rgba(0, 212, 255, 0.15);
  box-sizing: border-box;
}

.header_l {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 6px;
}

.logo_img {
  height: 28px;
  object-contain: fit;
}

.logo_text {
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #fff, #a5b4fc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.split_line {
  color: rgba(255, 255, 255, 0.2);
  font-size: 16px;
  margin: 0 4px;
}

.title {
  font-size: 15px;
  color: #e2e8f0;
  font-weight: 500;
}

/* 中间时钟样式 */
.header_c {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.clock_time {
  font-size: 14px;
  color: #9ca2ac;
  // font-weight: bold;
  // font-family: monospace;
  // color: #00d4ff;
  letter-spacing: 0.5px;
  text-shadow: 0 0 5px rgba(0, 212, 255, 0.3);
}

.clock_date {
  font-size: 10px;
  color: #64748b;
  margin-top: 2px;
  // font-family: monospace;
}

/* 用户区样式 */
.user {
  cursor: pointer;
  border: 1.5px solid rgba(0, 212, 255, 0.3);
}

.user_name {
  margin-right: 12px;
  color: #cbd5e1;
  font-weight: 500;
}

.text_dow {
  margin-right: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #94a3b8;
  font-size: 13px;
  transition: color 0.2s;

  &:hover {
    color: #fff;
  }
}

.text_logout {
  color: #f1f5f9;
  &:hover {
    color: #ef4444;
  }
}

/deep/.el-icon {
  font-size: 15px !important;
  margin-right: 4px;
}

.conle {
  font-size: 12px;
  margin: 0 10px;
  color: rgba(255, 255, 255, 0.2);
}
</style>
